export const HEADER_ERROR = 'Lo sentimos';
export const DEFAULT_MSG_ERROR = 'En estos momentos no podemos atender tu solicitud';
